import { combineReducers } from 'redux'
import global from './global'
import theme from './theme'
import notification from './notification'
import { connectRouter, routerMiddleware } from 'connected-react-router'

export default (history) => combineReducers({
  theme,
  global,
  notification,
  router: connectRouter(history)
})
